import aliases from './aliases';
import parentLocales from './parentLocales';
export function getParentLocaleHierarchy(locale) {
  var results = [];
  locale = aliases[locale] || locale;
  var parentLocale = parentLocales[locale];

  if (parentLocale) {
    results.push(parentLocale);
  }

  var localeParts = locale.split('-');

  for (var i = localeParts.length; i > 1; i--) {
    results.push(localeParts.slice(0, i - 1).join('-'));
  }

  return results;
}

function resolveSupportedLocale(locale, localeData) {
  if (!locale) {
    return;
  }

  var lowercasedLocale = locale.toLowerCase();

  if (lowercasedLocale in localeData) {
    return localeData[lowercasedLocale].locale || locale;
  }

  var alias = aliases[locale];

  if (alias) {
    var lowercasedAlias = alias.toLowerCase();

    if (lowercasedAlias in localeData) {
      return localeData[lowercasedAlias].locale || alias;
    }
  }

  var parentHierarchy = getParentLocaleHierarchy(locale);
  var parentLocale = locale;

  while (parentLocale) {
    parentLocale = parentHierarchy.shift();

    if (parentLocale) {
      var lowercasedParentLocale = parentLocale.toLowerCase();

      if (lowercasedParentLocale in localeData) {
        return localeData[lowercasedParentLocale].locale || parentLocale;
      }
    }
  }

  return;
}

export function supportedLocalesOf(locales, localeData) {
  var localeArray = Array.isArray(locales) ? locales : [locales];
  return localeArray.filter(function (l) {
    return !!resolveSupportedLocale(l, localeData);
  });
}
export function findSupportedLocale(locales, localeData) {
  var localeArray = Array.isArray(locales) ? locales : [locales];

  for (var i = 0; i < localeArray.length; i++) {
    var resolvedLocale = resolveSupportedLocale(localeArray[i], localeData);

    if (resolvedLocale) {
      return resolvedLocale;
    }
  }
}